@if (loading) {
  <div class="loading-indicator">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
<div class="rtnav ui-g">
  <div class="ui-g-8 msgbox-8">
    @for (message of custmsgs; track message) {
      <p-message [life]="3000" [text]="message.detail"></p-message>
    }
  </div>
  @if (!custbtnNav) {
    <div class="ui-g-3"></div>
  }
  @if (custbtnNav) {
    <div class="ui-g-3">
      <button
        type="button"
        pButton
        (click)="editCustomerCancel()"
        class="ui-button-secondary flat fl-rt">
        Cancel
      </button>
      <button
        type="submit"
        pButton
        (click)="onSubmitCustomer()"
        class="flat btnmr fl-rt">
        Save
      </button>
    </div>
  }
  <div class="ui-g-1 edit-history-icon">
    <span
      class="fa fa-pencil ico cpointer fl-rt"
      pTooltip="Edit"
      (click)="editCustomer()"
      (keydown.enter)="editCustomer()"
      tabindex="0"
      tooltipPosition="bottom"></span>
  </div>
</div>

<form [formGroup]="formCustomer">
  <div class="readonlytbox">
    <div class="ui-g">
      <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <div class="hdorg">System Generated</div>
      </div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <div class="hdorg">PMO Confirmed</div>
      </div>
    </div>
    <div class="ui-g">
      <div class="ui-g-12 ui-md-4 ui-lg-4">TPID</div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <input
          type="text"
          pInputText
          (keypress)="numberOnly($event)"
          readonly
          formControlName="tPID" />
      </div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <input
          type="text"
          pInputText
          (keypress)="numberOnly($event)"
          [readonly]="isReadonlycust"
          formControlName="pmotPID" />
      </div>
    </div>
    <div class="ui-g">
      <div class="ui-g-12 ui-md-4 ui-lg-4">TPName</div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <input type="text" pInputText readonly formControlName="tPName" />
      </div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <input
          type="text"
          pInputText
          [readonly]="isReadonlycust"
          formControlName="pmotPName" />
      </div>
    </div>
    <div class="ui-g">
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        Customer TPID List based on Tenant ID
      </div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <input
          type="text"
          pInputText
          readonly
          formControlName="customerTPIDListbasedonTenantID" />
      </div>
      <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
    </div>
    <div class="ui-g">
      <div class="ui-g-12 ui-md-4 ui-lg-4">Segment Group</div>
      <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <input
          type="text"
          pInputText
          [readonly]="isReadonlycust"
          formControlName="segmentGroup" />
      </div>
    </div>
    <div class="ui-g">
      <div class="ui-g-12 ui-md-4 ui-lg-4">Customer Area</div>
      <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <input
          type="text"
          pInputText
          [readonly]="isReadonlycust"
          formControlName="pmocustomerArea" />
      </div>
    </div>
    <div class="ui-g">
      <div class="ui-g-12 ui-md-4 ui-lg-4">Customer Country</div>
      <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <input
          type="text"
          pInputText
          [readonly]="isReadonlycust"
          formControlName="pmocustomerCountry" />
      </div>
    </div>
    <div class="ui-g">
      <div class="ui-g-12 ui-md-4 ui-lg-4">Usage Area</div>
      <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <input
          type="text"
          pInputText
          [readonly]="isReadonlycust"
          formControlName="pmousageArea" />
      </div>
    </div>
    <div class="ui-g">
      <div class="ui-g-12 ui-md-4 ui-lg-4">Usage Country</div>
      <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <input
          type="text"
          pInputText
          [readonly]="isReadonlycust"
          formControlName="pmousageCountry" />
      </div>
    </div>
    <div class="ui-g">
      <div class="ui-g-12 ui-md-4 ui-lg-4">Tenant ID</div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <input type="text" pInputText readonly formControlName="tenantID" />
      </div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <input
          type="text"
          pInputText
          [readonly]="isReadonlycust"
          formControlName="pmotenantID" />
      </div>
    </div>
    <div class="ui-g">
      <div class="ui-g-12 ui-md-4 ui-lg-4">Tenant Name</div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <input type="text" pInputText readonly formControlName="tenantName" />
      </div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <input
          type="text"
          pInputText
          [readonly]="isReadonlycust"
          formControlName="pmotenantName" />
      </div>
    </div>
    <div class="ui-g">
      <div class="ui-g-12 ui-md-4 ui-lg-4">Domain Name</div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <input type="text" pInputText readonly formControlName="domainName" />
      </div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <input
          type="text"
          pInputText
          [readonly]="isReadonlycust"
          formControlName="pmodomainName" />
      </div>
    </div>
    <div class="ui-g">
      <div class="ui-g-12 ui-md-4 ui-lg-4">Tenant List based on TPID</div>
      <div class="ui-g-12 ui-md-4 ui-lg-4">
        <input
          type="text"
          pInputText
          readonly
          formControlName="tenantListbasedonTPID" />
      </div>
      <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
    </div>
  </div>
</form>
